module.exports = __webpack_public_path__ + "img/circle-arrow-right.41eb2bd4.svg";